import { Api } from '@/api/Api'
import { HttpMethod } from '@/api/FetchApi'
import _ from 'lodash'
import { ActionTree } from 'vuex'
import { ResponseArray, RootState } from '../types'
import { blankInquiryArray, blankSearchFilters } from './constants'
import State, { INewInquiry, IInquiry, ISearchFilters } from './types'
import { IOrderCustomer, IOrderDocument } from '../orders/types'
import SecurityState from '../security/types'
const api = new Api()

export const actions: ActionTree<State, RootState> = {
  getInquiries({ commit, rootState }, searchFilters: ISearchFilters): any {
    const {
      page,
      sortBy,
      sortDesc,
      salesOrderNumber,
      customerName,
      customerNumber,
      inquiryDate,
      inquiryId,
      salesRep,
      keyTerm = '',
      inquiryStatus = '',
    } = searchFilters
    commit('inquiriesLoading')
    commit('searchFiltersSet', searchFilters)
    const pageSize = 10
    const url =
      `${rootState.apiPrefix ?? ''}/inquiry?PageSize=` +
      pageSize +
      '&Page=' +
      page +
      '&SalesOrderNumber=' +
      salesOrderNumber +
      '&Customer=' +
      encodeURIComponent(customerName ?? '') +
      '&CustomerNumber=' +
      encodeURIComponent(customerNumber ?? '') +
      '&InquiryDate=' +
      encodeURIComponent(inquiryDate ?? '') +
      '&SortBy=' +
      sortBy +
      '&SortDirection=' +
      (sortDesc ? 'desc' : 'asc') +
      '&InquiryId=' + inquiryId +
      (salesRep ? '&SalesRep=' + salesRep : '') +
      '&KeyTerm=' +
      encodeURIComponent(keyTerm ?? '') +
      '&InquiryStatus=' +
      encodeURIComponent(inquiryStatus ?? '')

    const securityState = (this.state as any).security as SecurityState
    return api
      .fetchV2({
        url,
        user: securityState.currentUser,
      })
      .then((response) => {
        const inquiries: ResponseArray<IInquiry> = _.assign(
          {},
          blankInquiryArray,
        )
        inquiries.loading = false
        inquiries.List = response.List
        // TODO: Exists a better way to do it?
        inquiries.Page = response.Page
        inquiries.PageSize = response.PageSize
        inquiries.Total = response.Total
        commit('inquiriesLoaded', inquiries)
        return inquiries
      })
      .catch(() => {
        commit('inquiriesError')
      })
  },
  async addInquiry({ commit, dispatch }, inquiry: INewInquiry) {
    try {
      commit('inquiryAdding')
      const url = '/inquiry'
      const obj = inquiry
      const body: BodyInit = new FormData()
      body.append('request', JSON.stringify({ Data: obj }))
      inquiry.Files?.forEach(file => body.append('files', file))
      const securityState = (this.state as any).security as SecurityState
      api
        .fetchV2({
          url,
          method: HttpMethod.Post,
          user: securityState.currentUser,
          body,
        })
        .then((response) => {
          if (response.InquiryId !== undefined && response.InquiryId !== null) {
            const savedInquiry: IInquiry = response
            commit('inquiryAdded', savedInquiry)
            dispatch('cart/clearCartItems', null, { root: true })
          } else {
            commit('inquiryAddedError', response.Message ?? response.Error)
          }
        })
        .catch(() => {
          commit(
            'inquiryAddedError',
            'Error processing request. Please try again later or contact support',
          )
        })
      return false
    } catch (error) {
      commit('inquiryAddedError')
    }
  },
  async saveInquiry({ commit, dispatch }, { inquiryId, inquiry }: { inquiryId: number, inquiry: INewInquiry }) {
    try {
      commit('inquiryAdding')
      const url = `/inquiry/${inquiryId}`
      const obj = inquiry
      const body: BodyInit = new FormData()
      body.append('request', JSON.stringify({ Data: obj }))
      inquiry.Files?.forEach(file => body.append('files', file))
      const securityState = (this.state as any).security as SecurityState
      api
        .fetchV2({
          url,
          method: HttpMethod.Post,
          user: securityState.currentUser,
          body,
        })
        .then((response) => {
          if (response.InquiryId !== undefined && response.InquiryId !== null) {
            const savedInquiry: IInquiry = response
            commit('inquiryAdded', savedInquiry)
            dispatch('cart/clearCartItems', null, { root: true })
          } else {
            commit('inquiryAddedError', response.Message ?? response.Error)
          }
        })
        .catch(() => {
          commit(
            'inquiryAddedError',
            'Error processing request. Please try again later or contact support',
          )
        })
      return false
    } catch (error) {
      commit('inquiryAddedError')
    }
  },
  async cancelInquiry({ commit, dispatch, rootState }, { inquiryId, cancelReason }: { inquiryId: number, cancelReason: string }) {
    try {
      dispatch('common/setOverlayShowing', true, { root: true })
      const url = `${rootState.apiPrefix ?? ''}/inquiry/${inquiryId}/cancel`
      const obj = { InquiryId: inquiryId, CancelReason: cancelReason }
      const securityState = (this.state as any).security as SecurityState
      api
        .fetchV2({
          url,
          method: HttpMethod.Post,
          user: securityState.currentUser,
          obj,
        })
        .then((response) => {
          if (response.Error || response.Message) {
            commit('inquiryCancelError', response.Message ?? response.Error)
            dispatch('common/setOverlayShowing', false, { root: true })
          } else {
            commit('inquiryChanged')
            dispatch('inquiries/fetchInquiry', inquiryId, { root: true })
          }
        })
        .catch(() => {
          commit(
            'inquiryCancelError', 'Error processing request. Please try again later or contact support',
          )
        })
      return false
    } catch (error) {
      commit('inquiryCancelError', error)
    }
  },
  async uncancelInquiry({ commit, dispatch, rootState }, { inquiryId }: { inquiryId: number }): Promise<boolean> {
    try {
      dispatch('common/setOverlayShowing', true, { root: true })
      const url = `${rootState.apiPrefix ?? ''}/inquiry/${inquiryId}/uncancel`
      const obj = { InquiryId: inquiryId }
      const securityState = (this.state as any).security as SecurityState
      const response = await api.fetchV2({
        url,
        method: HttpMethod.Post,
        user: securityState.currentUser,
        obj,
      })
      if (response.Error || response.Message) {
        commit('inquiryCancelError', response.Message ?? response.Error)
        dispatch('common/setOverlayShowing', false, { root: true })
        return false
      }
      commit('inquiryChanged')
      await dispatch('inquiries/fetchInquiry', inquiryId, { root: true })
      return true
    } catch (error) {
      commit(
        'inquiryCancelError',
        'Error processing request. Please try again later or contact support',
      )
      dispatch('common/setOverlayShowing', false, { root: true })
      return false
    }
  },
  async requestSpecialPricing({ commit, dispatch, rootState }, { inquiryId, requestNote }: { inquiryId: number, requestNote: string }) {
    try {
      dispatch('common/setOverlayShowing', true, { root: true })
      const url = `${rootState.apiPrefix ?? ''}/inquiry/${inquiryId}/requestPricing`
      const obj = { InquiryId: inquiryId, RequestNote: requestNote }
      const securityState = (this.state as any).security as SecurityState
      return api
        .fetchV2({
          url,
          method: HttpMethod.Post,
          user: securityState.currentUser,
          obj,
        })
        .then((response) => {
          if (response.Error || response.Message) {
            commit('inquiryCancelError', response.Message ?? response.Error)
            dispatch('common/setOverlayShowing', false, { root: true })
          } else {
            commit('inquiryChanged')
            dispatch('inquiries/fetchInquiry', inquiryId, { root: true })
          }
        })
        .catch(() => {
          commit(
            'inquiryCancelError', 'Error processing request. Please try again later or contact support',
          )
        })
      return false
    } catch (error) {
      commit('inquiryCancelError', error)
    }
  },
  async approveSpecialPricing({ commit, dispatch, rootState }, { inquiryId, prices }: { inquiryId: number, prices: [] }) {
    try {
      dispatch('common/setOverlayShowing', true, { root: true })
      const url = `${rootState.apiPrefix ?? ''}/inquiry/${inquiryId}/approvePricing`
      const obj = { InquiryId: inquiryId, Prices: prices }
      const securityState = (this.state as any).security as SecurityState
      return api
        .fetchV2({
          url,
          method: HttpMethod.Post,
          user: securityState.currentUser,
          obj,
        })
        .then((response) => {
          if (response.Error || response.Message) {
            commit('inquiryCancelError', response.Message ?? response.Error)
            dispatch('common/setOverlayShowing', false, { root: true })
          } else {
            commit('inquiryChanged')
            dispatch('inquiries/fetchInquiry', inquiryId, { root: true })
          }
        })
        .catch(() => {
          commit(
            'inquiryCancelError', 'Error processing request. Please try again later or contact support',
          )
        })
    } catch (error) {
      commit('inquiryCancelError', error)
    }
  },
  setActiveInquiry({ commit }, inquiry: IInquiry) {
    try {
      commit('activeInquirySet', inquiry)
    } catch (error) {
      commit('activeInquiryError')
    }
  },
  async fetchInquiry(
    { commit, dispatch, state, rootState },
    inquiryId: number | string,
  ) {
    const id =
      typeof inquiryId === 'string' ? parseInt(inquiryId, 10) : inquiryId
    if (!Number.isFinite(id) || id < 1) {
      commit('activeInquiryError')
      return
    }
    dispatch('common/setOverlayShowing', true, { root: true })
    try {
      let inquiry: IInquiry | undefined
      if (!state.inquiryChanged && state.inquiries?.List?.length) {
        inquiry = state.inquiries.List.find((x) => x.InquiryId === id)
      }
      if (inquiry) {
        commit('activeInquirySet', inquiry)
        return
      }
      const url = `${rootState.apiPrefix ?? ''}/inquiry/${id}`
      const securityState = (this.state as any).security as SecurityState
      const response: any = await api.fetchV2({
        url,
        user: securityState.currentUser,
      })
      if (response?.Successful !== false && response?.InquiryId) {
        commit('activeInquirySet', response as IInquiry)
      } else {
        commit('activeInquiryError')
      }
    } catch (error) {
      commit('activeInquiryError')
    } finally {
      dispatch('common/setOverlayShowing', false, { root: true })
    }
  },

  setIsSubmitting({ commit }, isSubmittingInquiry) {
    commit('isSubmittingSet', isSubmittingInquiry)
  },

  setCurrentInquiry({ commit }, inquiry: IInquiry) {
    try {
      commit('currentInquirySet', inquiry)
    } catch (error) {
      commit('currentInquiryError')
    }
  },

  resetCurrentInquiry({ commit }) {
    commit('currentInquiryReset')
  },
  setValidationErrors({ commit }, errors: object) {
    try {
      commit('validationErrorsSet', errors)
    } catch (error) {
      commit('validationErrorsError')
    }
  },
  resetInquiry({ dispatch }) {
    dispatch('cart/clearCartItems', null, { root: true })
    dispatch('inquiries/setIsSubmitting', false, { root: true })
    dispatch('order-state/clearCustomerShipTos', null, { root: true })
    dispatch('multiplier/clearCustomerMultipliers', null, { root: true })
  },
  fetchCustomers({ commit, rootState }, { salesRepId }): any {
    let url = `${rootState.apiPrefix ?? ''}/Customer/all?`

    if (salesRepId && salesRepId !== '') {
      url += `salesRep=${salesRepId}`
    }
    const securityState = (this.state as any).security as SecurityState
    return api
      .fetchV2({
        url,
        user: securityState.currentUser,
      })
      .then((response) => {
        const result = response.List
        const customers: ResponseArray<IOrderCustomer> = result.map(
          (c: any) => {
            const customer: IOrderCustomer = {
              poNumber: '',
              customerNo: c.CustomerNumber,
              companyName: c.CustomerName,
              isCreditBlocked: c.IsCreditBlocked,
              customerSalesText: c.CustomerSalesText,
              customerShippingText: c.CustomerShippingText,
              address: {
                Name: c.CustomerName,
                Address1: c.CustomerAddress.Street,
                Address2: '',
                State: c.CustomerAddress.Region,
                City: c.CustomerAddress.City,
                Zip: c.CustomerAddress.PostalCode,
                Phone: c.CustomerAddress.Phone,
                Country: c.CustomerAddress.Country,
              },
              shippingMethod: 'Best Way',
              paymentTerm: c.PaymentTerm,
              divisionCode: c.DivisionCode,
              divisionText: c.DivisionText,
            }
            return customer
          },
        )

        commit('customersLoaded', customers)
        return customers
      })
      .catch(() => {
        commit('customersErrors')
      })
  },
  resetSearchFilters({ commit }) {
    commit('searchFiltersSet', blankSearchFilters)
  },
  setCurrentCustomer({ commit }, { customerNo, divisionCode, divisionText }: { customerNo: string, divisionCode: string, divisionText: string }) {
    commit('setCurrentCustomer', { customerNo, divisionCode, divisionText })
  },
  async fetchDocuments({ commit }, inquiryId: number) {
    try {
      commit('inquiryDocumentsLoading')
      const securityState = (this.state as any).security as SecurityState
      const url = `/inquiry/documents/${inquiryId}`
      await api
        .fetchV2({
          url,
          user: securityState.currentUser,
        })
        .then((response) => {
          const error = response.Message ?? response.Error
          if (error) {
            commit('inquiryDocumentError', error)
          } else {
            const documents: IOrderDocument[] = response
            commit('inquiryDocumentsSet', documents)
          }
        })
      return false
    } catch (error) {
      commit('inquiryDocumentsSet', [])
      commit('inquiryDocumentError', error)
    }
  },
  async uploadDocuments({ commit, dispatch, rootState }, { inquiryId, files }: { inquiryId: number, files: File[] }) {
    try {
      commit('inquiryDocumentsLoading')
      const url = `${rootState.apiPrefix ?? ''}/inquiry/document/${inquiryId}`
      const body: BodyInit = new FormData()
      files.forEach(file => body.append('files', file))
      const securityState = (this.state as any).security as SecurityState
      api
        .fetchV2({
          url,
          method: HttpMethod.Post,
          user: securityState.currentUser,
          body,
        })
        .then((response) => {
          const error = response.Message ?? response.Error
          if (error) {
            commit('inquiryDocumentError', error)
          } else {
            dispatch('inquiries/fetchDocuments', inquiryId, { root: true })
          }
        })
        .catch(() => {
          commit(
            'inquiryDocumentError',
            'Error processing request. Please try again later or contact support',
          )
        })
      return false
    } catch (error) {
      commit('inquiryDocumentsSet', [])
      commit('inquiryDocumentError', error)
    }
  },
  async fetchConfigurations({ commit, rootState }, inquiryId: number) {
    try {
      const url = `${rootState.apiPrefix ?? ''}/inquiry/${inquiryId}/configurations`
      const securityState = (this.state as any).security as SecurityState
      return api
        .fetchV2({
          url,
          method: HttpMethod.Get,
          user: securityState.currentUser,
        })
        .then((response) => {
          return response
        })
        .catch(() => {
          commit(
            'inquiryDocumentError',
            'Error processing request. Please try again later or contact support',
          )
        })
    } catch (error) {
      commit('inquiryDocumentError', error)
    }
  },
  async deleteDocuments({ commit, dispatch, rootState }, { inquiryId, documentId }: { inquiryId: number, documentId: number }) {
    try {
      commit('inquiryDocumentsLoading')
      const url = `${rootState.apiPrefix ?? ''}/inquiry/document/delete/${documentId}`
      const securityState = (this.state as any).security as SecurityState
      await api
        .fetchV2({
          url,
          method: HttpMethod.Post,
          user: securityState.currentUser,
        })
        .then((response) => {
          const error = response.Message ?? response.Error
          if (error) {
            commit('inquiryDocumentError', error)
          } else {
            dispatch('inquiries/fetchDocuments', inquiryId, { root: true })
          }
        })
      return false
    } catch (error) {
      commit('inquiryDocumentsSet', [])
      commit('inquiryDocumentError', error)
    }
  },
}
